import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {
  p: 2,
};

export const container: SxStyleFunc<string | undefined> = (color) => ({
  p: 1,
  height: (p) => p.spacing(25),
  background: `linear-gradient(180deg, #F9FAFB 0%, ${color || '#F1F4FF'} 100%)`,
});

export const header: SxStyleFunc<string | undefined> = (color) => ({
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: color || ((p) => p.palette.primary[100]),
  borderRadius: (p) => p.spacing(1),
  p: (p) => p.spacing(1, 2.5),
});

export const iconWrapper: SxStyle = {
  position: 'relative',
  mt: (p) => p.spacing(1),
};

export const count: SxStyleFunc<string | undefined> = (color) => ({
  position: 'absolute',
  fontSize: '10px',
  top: -7,
  right: -5,
  backgroundColor: color || ((p) => p.palette.primary[500]),
  color: (p) => p.palette.common.white,
  width: (p) => p.spacing(2),
  height: (p) => p.spacing(2),
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const bell: SxStyleFunc<string | undefined> = (color) => ({
  color: color || ((p) => p.palette.primary[500]),
});

export const avatarWrapper: SxStyleFunc<string | undefined> = (color) => ({
  color: color || ((p) => p.palette.primary[500]),
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: color || ((p) => p.palette.primary[100]),
  width: (p) => p.spacing(3.5),
  height: (p) => p.spacing(3.5),
  borderRadius: (p) => p.spacing(0.5),
});

export const avatar: SxStyleFunc<string | undefined> = (color) => ({
  color: color || ((p) => p.palette.primary[500]),
});

export const notifHeader: SxStyleFunc<string | undefined> = (color) => ({
  px: (p) => p.spacing(1.5),
  py: (p) => p.spacing(1),
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: color || ((p) => p.palette.primary[100]),
});

export const notif: SxStyleFunc<string | undefined> = (color) => ({
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: color || ((p) => p.palette.primary[100]),
  borderRadius: (p) => p.spacing(1),
});

export const notifTitle: SxStyleFunc<string | undefined> = (color) => ({
  color: color || ((p) => p.palette.primary[500]),
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightBold,
});

export const content: SxStyleFunc<string | undefined> = (color) => ({
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: color || ((p) => p.palette.primary[100]),
  p: (p) => p.spacing(1, 0.5),
  borderRadius: (p) => p.spacing(0.5),
});

export const button: SxStyleFunc<string | undefined> = (color) => ({
  background: color || ((p) => p.palette.primary[500]),
  color: (p) => p.palette.common.white,
  fontSize: '10px',
  width: (p) => p.spacing(6.5),
  textAlign: 'center',
  p: (p) => p.spacing(0.5),
  borderRadius: (p) => p.spacing(0.5),
});

export const date: SxStyle = {
  fontSize: '10px',
  color: (p) => p.palette.grey[500],
};

export const description: SxStyleFunc<boolean | undefined> = (isName) => ({
  fontSize: '8px',
  fontWeight: isName
    ? (p) => p.typography.fontWeightBold
    : (p) => p.typography.fontWeightLight,
  color: (p) => p.palette.grey[600],
});

export const title: SxStyleFunc<string | undefined> = (color) => ({
  color: color || ((p) => p.palette.primary[500]),
  fontSize: '10px',
  fontWeight: (p) => p.typography.fontWeightBold,
});

export const unread: SxStyleFunc<boolean | undefined> = (isRead) => ({
  width: (p) => p.spacing(1.5),
  height: (p) => p.spacing(1.5),
  borderRadius: '50%',
  background: (p) => p.palette.success[400],
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.success[100],
  display: isRead ? 'none' : 'flex',
});

export const clear: SxStyle = {
  fontSize: '10px',
  fontWeight: (p) => p.typography.fontWeightBold,
};
